import { relatoryPost } from './methods';
import { ListagemLoginsRequest, UsuarioCadastrosRequest } from './usuario';

export interface PresencaRequest {
  idEvento: number;
  agencias?: Array<string>;
  cpfOrNome?: string;
  nucleos?: Array<string>;
  page?: number;
  size?: number;
}

export interface DownloadExcelAgn {
  idEvento: number;
  agencias: Array<string>;
  nucleos: Array<string>;
  quorumAtingido: any;
}

export interface DownloadExcelAgoAgeAoe {
  idEvento: number;
  agencias: Array<string>;
  nucleos: Array<string>;
  representado: any;
}

const relatorios = {
  historico: (eventId: number) => {
    return relatoryPost<ArrayBuffer>('presenca/input-output', undefined, {
      responseType: 'arraybuffer',
      params: { eventId },
    });
  },
  logins: (
    request: Partial<ListagemLoginsRequest>,
    page?: number,
    size?: number
  ) => {
    return relatoryPost<ArrayBuffer>(
      'login-associado/logins-authcorp/csv',
      request,
      {
        params: { page, size },
      }
    );
  },
  cadastros: (request: Partial<UsuarioCadastrosRequest>) => {
    return relatoryPost<ArrayBuffer>('login-associado', request, {
      responseType: 'arraybuffer',
    });
  },
  downloadResultadoParcialAGOAGEAOE: (idPauta: number | string) => {
    return relatoryPost<ArrayBuffer>(
      `evento/resultado-parcial/ago-age-aoe`,
      undefined,
      {
        responseType: 'arraybuffer',
        params: { idPauta },
      }
    );
  },
};

export default relatorios;
